<template>
    <PageLoading v-if="isLoading" />
    <div
        v-else
        class="main-wrap about-page"
    >
        <div class="banner-wrap">
            <h1>
                {{ objectKeyTranslation(aboutInfo.header_title, 'word1', locale.key) }}
                <br />
                <span>{{ objectKeyTranslation(aboutInfo.header_title, 'word2', locale.key) }}</span>
                <br />
                {{ objectKeyTranslation(aboutInfo.header_title, 'word3', locale.key) }}
            </h1>
            <q-icon
                v-scroll-to="'#anchor'"
                class="scroll-to-btn"
                name="arrow_back_ios"
            ></q-icon>
        </div>
        <div
            id="anchor"
            class="about-us"
        >
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="text-wrap text-justify">
                        <h2>{{ JSONParseTranslations(aboutInfo.first_title, locale.key) }}</h2>
                        <h4>{{ JSONParseTranslations(aboutInfo.first_subtitle, locale.key) }}</h4>
                        <span v-html="JSONParseTranslations(aboutInfo.first_content, locale.key)"></span>
                    </div>
                </div>
                <div class="about-img-right col-12 col-md-6">
                    <img
                        :src="firstImage"
                        alt="CFMA"
                    />
                </div>
            </div>
        </div>
        <div class="why-us">
            <div class="banner-img">
                <img
                    :src="secondImage"
                    alt="CFMA"
                />
            </div>
            <div class="text-wrap row">
                <h2>{{ JSONParseTranslations(aboutInfo.second_title, locale.key) }}</h2>
                <div class="col-12 col-md-6 text-justify">
                    <h3>{{ JSONParseTranslations(aboutInfo.second_subtitle, locale.key) }}</h3>
                </div>
                <div class="col-12 col-md-6 text-justify">
                    <span v-html="JSONParseTranslations(aboutInfo.second_content, locale.key)"></span>
                </div>
            </div>
        </div>
        <div class="why-us">
          <div class="text-wrap text-justify">
            <h2>{{$t('general.board_message_title')}}</h2>
            <h3 v-html="JSONParseTranslations(aboutInfo.board_message, locale.key)"></h3>
          </div>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import PageLoading from '@/components/PageLoading'
import aboutService from '@/services/modules/about'
import picturesService from '@/services/pictures'
import encoders from '@/helpers/encoders'
import store from '@/store'

const loadingKeys = {
    fetchingAbout: 'fetching-about',
}

export default {
    name: 'AboutCFMA',

    components: {
        PageLoading,
    },

    mixins: [translate],

    data() {
        return {
            aboutInfo: {},
            firstImage: '',
            secondImage: '',
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingAbout
        },

        isFetchingAbout() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingAbout
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        }
    },

    async created() {
        await this.fetchAbout()
    },

    methods: {
        async fetchAbout() {
            this.loadingAdd(loadingKeys.fetchingAbout)

            let parameters = {}

            let response = await aboutService.retrieve(parameters)

            if (response.status === 200) {
                this.aboutInfo = response.data.results[0]
                this.aboutInfo.header_title = JSON.parse(this.aboutInfo.header_title)
                if (this.aboutInfo.first_picture_id) {
                    let imageResponse = await picturesService.retrieveById(this.aboutInfo.first_picture_id)
                    if (imageResponse.status === 200) {
                        this.firstImage = encoders.arrayBufferToBase64(imageResponse)
                    }
                }
                if (this.aboutInfo.second_picture_id) {
                    let imageResponse = await picturesService.retrieveById(this.aboutInfo.second_picture_id)
                    if (imageResponse.status === 200) {
                        this.secondImage = encoders.arrayBufferToBase64(imageResponse)
                    }
                }
            }

            this.loadingRemove(loadingKeys.fetchingAbout)
        }

    },
}
</script>
